<template>
  <div class="py-8 property">
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link
          class="text-decoration--none"
          :to="{ name: 'user.reports' }"
        >
          Reported Users
        </router-link>
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4">
      <div class="d-md-flex">
        <div class="col-md-6 col-sm-12 col-xs-12 pa-lg-0">
          <h3 class="py-5 primary--text">Reported User Information</h3>
          <v-row>
            <div class="col-sm-6 col-xs-12 property__detail" v-if="report">
              <h2 class="py-2">Report Details</h2>
              <div class="pa-0">
                <p class=" property__detail__text">
                  Reported:
                  {{ details.reporter ? details.reportable.full_name : '' }}
                </p>
                <p class="property__detail__text">
                  Reported by:
                  {{ details.reporter ? details.reporter.full_name : '' }}
                </p>
                <p class="property__detail__text">
                  Reason: {{ details.reporter ? details.reason.label : '' }}
                </p>
                <p class="property__detail__text">
                  Description: {{ details.reporter ? details.description : '' }}
                </p>
                <p class="property__detail__text">
                  Reported Date: {{ details.addedDate }}
                </p>
                <p class=" property__detail__text">
                  User Status:
                  <span
                    v-if="details.reportable && !details.reportable.blocked_at"
                    class="green--text"
                  >
                    Active
                  </span>
                  <span
                    v-if="details.reportable && details.reportable.blocked_at"
                    class="red--text"
                  >
                    Blocked
                  </span>
                </p>
              </div>
            </div>
            <div class="col-sm-6 col-xs-12"></div>
            <div class="col-sm-12 col-xs-12">
              <h2 class="py-5">Attachments</h2>
              <template max-width="344">
                <v-carousel
                  v-if="details.attachments && details.attachments.length > 0"
                  height="400"
                  width="200"
                  hide-delimiters
                  :show-arrows="showArrow(details.attachments)"
                >
                  <v-carousel-item
                    v-for="(item, i) in details.attachments"
                    :key="i"
                    :src="item.url"
                  ></v-carousel-item>
                </v-carousel>

                <p v-else>No attachments available</p>
              </template>
            </div>
          </v-row>
        </div>
      </div>
      <div class="mt-4 col-md-6 col-sm-12 col-xs-12 pa-0">
        <v-btn
          color="error lighten-1"
          class="mr-4 px-6 "
          height="40px"
          width="20%"
          @click="disableDialog = true"
          :disabled="
            details.reportable && details.reportable.blocked_at !== null
          "
          >Disable User</v-btn
        >
        <v-btn
          class="ml-3 px-6"
          :to="{ name: 'user.reports' }"
          height="40px"
          width="20%"
          >cancel</v-btn
        >
      </div>
      <v-dialog v-model="disableDialog" max-width="350">
        <v-card>
          <v-card-title class="headline">Disable reported user</v-card-title>

          <v-card-text
            >Are you sure you want to disable reported user ?</v-card-text
          >

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn text @click="disableDialog = false" :loading="false"
              >Cancel</v-btn
            >

            <v-btn
              color="red"
              text
              @click="disableIncident(report.reportable.id)"
              :loading="btnLoading"
              >Ok</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
        {{ snackbar.message }}
        <v-btn text @click="snackbar.show = false">OK</v-btn>
      </v-snackbar>
    </div>
    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import { mdiChevronLeft, mdiCheck, mdiAlertCircleOutline } from '@mdi/js'
import { mapState } from 'vuex'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default {
  name: 'IncidentDetails',

  components: {
    AppBarNavIcon
  },

  data() {
    return {
      btnLoading: false,
      icons: {
        arrowLeft: mdiChevronLeft,
        check: mdiCheck,
        alert: mdiAlertCircleOutline
      },
      loading: false,
      disableDialog: false,
      snackbar: {
        show: false,
        message: null,
        color: ''
      },
      showModal: false
    }
  },

  computed: {
    ...mapState({
      report: state => state.userReport.reportDetails,
      authUser: state => state.auth.user
    }),
    disableMessage() {
      const action = this.user && this.user.blocked_at ? 'unblock' : 'block'
      return `Are you sure you want ${action} this account?`
    },
    details() {
      return this.report
    }
  },

  methods: {
    init() {
      this.loading = true
      this.$store.dispatch('userReport/getReportDetails', this.$route.params.id)
      this.loading = false
    },

    disableIncident(id) {
      this.btnLoading = true
      const action = this.details.reportable.blocked_at
        ? 'unblocked'
        : 'blocked'

      this.$store
        .dispatch('user/blockUser', {
          id: id,
          action
        })
        .then(() => {
          this.init()
          this.btnLoading = false
          this.disableDialog = false
          this.showSnackbar(`User successfully ${action}!`, 'success')
        })
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    },

    showArrow(photos) {
      return photos.length > 1
    }
  },

  created() {
    this.init()
  },

  watch: {
    $route() {
      this.$store.dispatch('userReport/getReportDetails', this.$route.params.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.user-form {
  width: 400px;

  @media (max-width: 420px) {
    width: 100%;
  }
}

.property {
  &__detail,
  &__status,
  &__feature {
    &__text {
      color: $black;
      font-size: 1rem;
    }
  }
}
</style>
